import React, { Component } from 'react'
import Row from "antd/lib/row";
import Form, {
    FormComponentProps
} from 'antd/lib/form';
import update from 'immutability-helper';
import { createStore } from "redux";
import { Provider } from 'react-redux'

import FormScheme, { FormGroup, FormItem, ClassType } from "../core/FormScheme";
import { SetComponent } from "../core/ComponentRegistor";
import FormItemDragComponent from "./FormItemDragComponent";
import FormGroupComponent from "./FormGroupDragComponent";
import rootReducer from "./reducers";

import { AntInput } from "../input/Ant-Input";
import { AntTextarea } from "../input/Ant-textarea";
import { AntTableForm } from "../table/Ant-table";

import { MdInput } from "../md/input/Md-Input";
import { AntCheckboxContainer } from '../utils/Ant-CheckboxAntCheckboxContainer';

const store = createStore(rootReducer)

export class DynamicDragForm extends Component<any, {
    formScheme: FormScheme,
}> {
    constructor(props) {
        super(props)
        SetComponent(props.formScheme)
        this.state = {
            formScheme: props.formScheme
        }
        const formItems = [
            AntInput,
            AntTextarea,
            AntTableForm,
            MdInput,
            AntCheckboxContainer
        ]
        let onSelectChange = (item, formKey) => { }
        if (props.onSelectChange) {
            onSelectChange = props.onSelectChange
        }
        const unsubscribe = store.subscribe(() => {
            // console.log("store.getState().selectedItem", store.getState().selectedItem)
            onSelectChange(store.getState().selectedItem, store.getState().formKey)
        })
    }

    moveField = (dragIndex, hoverIndex, dragFormKey, hoverFormKey) => {
        let dragObject = this.getItemList(dragFormKey)
        let hoverObject = this.getItemList(hoverFormKey)
        let dragList: (FormGroup | FormItem)[] = dragObject.list
        let hoverList: (FormGroup | FormItem)[] = hoverObject.list

        const dragItem = dragList[dragIndex];

        if (this.dragToKeyExist(dragItem, hoverIndex, hoverList)) {
            alert("key值冲突,请修改key值")
            return
        }
        // dragList.splice(dragIndex, 1)
        // hoverList.splice(hoverIndex, 0, dragItem)

        // dragObject.parentObject.children = dragList
        // hoverObject.parentObject.children = hoverList

        dragObject.parentObject.children = update(dragObject.parentObject.children, {
            $splice: [[dragIndex, 1]],

        })
        hoverObject.parentObject.children = update(hoverObject.parentObject.children, {
            $splice: [[hoverIndex, 0, dragItem]],
        })

        // const children = this.state.formScheme.children
        // const dragField = children[dragIndex];
        // const newformScheme: any = update(this.state.formScheme, {
        //     children: {
        //         $splice: [[dragIndex, 1], [hoverIndex, 0, dragField]],
        //     },
        // })
        this.setState({
            formScheme: update(this.state.formScheme, {
                $merge: this.state.formScheme
            })
        });
        this.onFormSchemeChange()
    }

    dragToKeyExist(dragItem, hoverIndex, hoverList: any[]): boolean {
        return hoverList.find((item, index) => {
            return dragItem.key === item.key
                && hoverIndex === index
        })
    }

    getItemList(formKey: string): {
        list: any[],
        parentObject: any,
    } {
        let curList = this.state.formScheme.children
        let parentObject = this.state.formScheme
        let keys: any[] = formKey.split(".")
        for (let index = 0; index < keys.length; index++) {
            let curKey = keys[index]
            let item: any = curList.find(item => {
                return item.key === curKey
            })
            if (item.children) {
                curList = item.children
                parentObject = item
            }
        }
        return {
            list: curList,
            parentObject: parentObject
        }
    }

    addField = (item: ClassType, addindex) => {
        // if (fieldItem.)
        let newItem: FormItem = this.getField(item)
        const newformScheme = update(this.state.formScheme, {
            children: {
                $splice: [[addindex, 0, newItem]],
            },
        })
        // console.log("fields", newFields)
        this.setState({
            formScheme: update(this.state.formScheme, {
                $merge: newformScheme
            })
        });
        this.onFormSchemeChange()
    }
    itemClick = (item: ClassType, addindex) => {
        // if (fieldItem.)
        alert(item)
    }

    fieldSeq: number = 0
    getField(item: ClassType): FormItem {
        let seq = this.fieldSeq++
        return {
            key: item.componentTag + seq,
            name: (item.componentName || item.componentTag) + seq,
            class: item,
            props: item.defaultProps || {}
        }
    }

    onFormSchemeChange(formScheme?) {
        if (this.props.onFormSchemeChange) {
            this.props.onFormSchemeChange(this.state.formScheme)
        }
    }

    render() {
        const formItems = this.state.formScheme.children.map((item: FormItem | FormGroup, index) => {
            if ((item as any).class) {
                return (
                    <FormItemDragComponent key={item.key} formKey={item.key} name={item.name} class={(item as FormItem).class}
                        {...(item as FormItem).props} {...this.props} item={item} index={index} moveField={this.moveField}
                        addField={this.addField} itemClick={this.itemClick}></FormItemDragComponent>
                )
            } else {
                return (
                    <FormGroupComponent key={item.key} formKey={item.key} name={item.name} items={(item as FormGroup).children}
                        {...this.props} item={item} index={index} moveField={this.moveField}
                        addField={this.addField} itemClick={this.itemClick}></FormGroupComponent>
                );
            }
        })
        return (
            <Provider store={store}>
                <Form>
                    <Row gutter={16} type="flex" justify="start">
                        {/* <Row gutter={16}> */}
                        {formItems}
                    </Row>
                </Form>
            </Provider>
        )
    }
}
interface AntWfFormProps extends FormComponentProps {
    onSubmit?: (e) => {} | void,
    form: any,
    formScheme: FormScheme,
    formLayout?: string,
    onSelectChange: (item, formKey) => void
    onFormSchemeChange: (formScheme) => void
}

export const WrappedDynamicDragForm = Form.create<AntWfFormProps>({ name: 'antWfForm' })(DynamicDragForm);